import React from 'react';
import { TableToggleAllRowsSelectedProps, TableToggleRowsSelectedProps } from 'react-table';

import TableCheckboxView from './TableCheckbok.view';

type Props = (TableToggleAllRowsSelectedProps | TableToggleRowsSelectedProps) & {
  disabled?: boolean;
  rowCheckbox?: boolean;
  onToggle?: () => void;
};

const TableCheckbox: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const promptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event);
    props.onToggle?.();
  };

  return (
    <TableCheckboxView
      className={props.className}
      rowCheckbox={props.rowCheckbox}
      checked={props.checked}
      disabled={props.disabled}
      onChange={promptChange}
    ></TableCheckboxView>
  );
};

TableCheckbox.displayName = 'TableCheckbox';

export default TableCheckbox;
